/* Circulis ™ — tout élément [data-crl-scroll] ramène à la fiche produit
   puis au sélecteur de quantité (paliers) et le met en évidence. */
(function () {
  function findTargets() {
    var main =
      document.querySelector('[id^="MainProduct-"]') ||
      document.querySelector('.main-product-section') ||
      document.querySelector('[id^="shopify-section-"][id$="__main"]');
    var qty =
      document.querySelector('.quantity-breaks-container') ||
      document.querySelector('.quantity-break') ||
      document.querySelector('variant-radios, variant-selects, .product-form__input') ||
      document.querySelector('.product-form__buttons');
    return { main: main, qty: qty };
  }

  function topOf(el) {
    var r = el.getBoundingClientRect();
    return r.top + (window.pageYOffset || document.documentElement.scrollTop);
  }

  function headerOffset() {
    var h = document.querySelector('.header-wrapper, header.header, sticky-header, #shopify-section-header');
    if (!h) return 16;
    var hb = h.getBoundingClientRect();
    var fixed = window.getComputedStyle(h).position;
    if (fixed === 'fixed' || fixed === 'sticky') return hb.height + 14;
    return 16;
  }

  function goTo(y) {
    y = Math.max(0, y);
    try {
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, y);
    }
    // repli : si "smooth" n'est pas supporté, on force la position
    setTimeout(function () {
      if (Math.abs((window.pageYOffset || 0) - y) > 120) window.scrollTo(0, y);
    }, 700);
  }

  function flash(el) {
    if (!el) return;
    el.classList.remove('crl-flash');
    void el.offsetWidth;
    el.classList.add('crl-flash');
    setTimeout(function () { el.classList.remove('crl-flash'); }, 1800);
  }

  function run() {
    var t = findTargets();
    var off = headerOffset();
    if (t.qty) {
      goTo(topOf(t.qty) - off - 24);
      flash(t.qty);
    } else if (t.main) {
      goTo(topOf(t.main) - off);
      flash(t.main);
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-crl-scroll]') : null;
    if (!el) return;
    e.preventDefault();
    run();
    // deuxième passe au cas où la mise en page bouge (images, polices)
    setTimeout(run, 60);
  });
})();

/* Regroupe les blocs « Argument » consécutifs de la fiche produit en une seule carte.
   Chaque argument reste un bloc indépendant dans le customizer ; le thème pose un
   `gap` sur le conteneur de la fiche produit, d'où ce regroupement en DOM. */
(function () {
  function group() {
    var items = document.querySelectorAll('.crl-bb__benefit');
    if (!items.length) return;
    var i, el, wrap;
    for (i = 0; i < items.length; i++) {
      el = items[i];
      if (el.parentNode && el.parentNode.classList.contains('crl-bb__benefits')) continue;
      var prev = el.previousElementSibling;
      if (prev && prev.classList.contains('crl-bb__benefits')) {
        prev.appendChild(el);
        continue;
      }
      wrap = document.createElement('div');
      wrap.className = 'crl-bb crl-bb__benefits';
      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(el);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', group);
  else group();
  document.addEventListener('shopify:section:load', group);
  document.addEventListener('shopify:block:select', group);
})();
